function OffenderCategory() {
    "use strict";

    this.__type = 'OffenderCategory:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;
    this.IsActive = true;
    this.MetaEnrolleeCategoryId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderCategory;
}